import type {
  LateNotice,
  ReportedAllergy,
  ScanResult,
} from '@/features/queue/types';
import { CLINIC_TZ } from '@/lib/clinic-time';

const TZ = CLINIC_TZ;

/** "10:05" in clinic time (Asia/Kuala_Lumpur), whatever the browser's zone. */
export function klClock(iso: string) {
  return new Date(iso).toLocaleTimeString('en-GB', {
    timeZone: TZ,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

/** "Thu 8 Oct, 19:02" in clinic time. */
export function klWhen(iso: string) {
  return new Date(iso).toLocaleString('en-GB', {
    timeZone: TZ,
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

/** The API sends 10, 20 or 30 minutes; 30 means "30 minutes or more". */
export function lateMinutesLabel(minutes: LateNotice['minutes']) {
  return minutes >= 30 ? '30 min or more' : `about ${minutes} min`;
}

/** "Running late: about 10 min · sent 10:05" */
export function lateNoticeLabel(n: LateNotice) {
  return `Running late: ${lateMinutesLabel(n.minutes)} · sent ${klClock(n.sentAt)}`;
}

/** Labels for `ScanResultDto.via`. */
export const VIA_LABELS: Record<ScanResult['via'], string> = {
  app_pass: 'App pass',
  counter_token: 'Counter token',
};

export const SCAN_RESULT_LABELS: Record<ScanResult['result'], string> = {
  checked_in: 'Checked in',
  walk_in: 'Walk-in: no booking today',
};

export function allergyLine(a: ReportedAllergy) {
  return [a.substance, a.reaction, a.severity].filter(Boolean).join(' · ');
}
